import MappingAndonProduction from '@/models/MappingAndonProduction/MappingAndonProduction';

export default class MappingAndonProductionFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.andonName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			andonName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}